"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontStyleButton = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const Ripple_1 = require("../../misc/Ripple");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.drule)({
    d: 'inline-flex',
    jc: 'space-around',
    ai: 'center',
    bdrad: '16%',
    cur: 'default',
    lh: '1.5em',
    out: 0,
    bd: 0,
    bxz: 'border-box',
    us: 'none',
    minW: 0,
});
const verticalClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    fld: 'column',
    jc: 'space-around',
    ai: 'center',
});
const displayClass = (0, nano_theme_1.drule)({
    d: 'inline-flex',
    jc: 'space-around',
    ai: 'center',
    cur: 'default',
    pdt: '.25em',
});
const childrenClass = (0, nano_theme_1.rule)({
    fz: '.65em',
    pdt: '.3em',
});
const FontStyleButton = ({ kind, size = 64, display = 'Ag', active, children, ...rest }) => {
    const styles = (0, context_1.useStyles)();
    const activeBg = styles.col.accent(0, 'bg-2');
    const accentColor = styles.col.get('accent', 'solid-1');
    const className = (rest.className ?? '') +
        blockClass({
            col: styles.g(0),
            w: size + 'px',
            h: size + 'px',
            bg: active ? activeBg : styles.g(0, 0.01),
            '&:hover': {
                bg: active ? activeBg : styles.g(0, 0.04),
            },
        });
    const classNameText = displayClass({
        ff: kind === 'serif'
            ? nano_theme_1.lightTheme.font.serif.mid.ff
            : kind === 'sans'
                ? nano_theme_1.lightTheme.font.sans.mid.ff
                : kind === 'slab'
                    ? nano_theme_1.lightTheme.font.slab.mid.ff
                    : nano_theme_1.lightTheme.font.mono.mid.ff,
        fz: size * 0.4 + 'px',
    });
    return (React.createElement(Ripple_1.Ripple, { ms: 1000 },
        React.createElement("button", { ...rest, type: "button", className: className },
            React.createElement("span", { className: verticalClass },
                React.createElement("span", { className: classNameText, style: { color: active ? accentColor : void 0 } }, display),
                size > 32 && (React.createElement("span", { className: childrenClass, style: { color: active ? accentColor : styles.g(0, 0.7) } }, children ?? (kind === 'serif' ? 'Serif' : kind === 'sans' ? 'Sans' : kind === 'slab' ? 'Slab' : 'Mono')))))));
};
exports.FontStyleButton = FontStyleButton;
